module.exports = __webpack_public_path__ + "static/media/returned-payments.13e771e1.svg";